import React, { useEffect } from "react";
import { Card, List } from "antd";
import AdqCard from "../AdqGrid/adqCard";
import { useState } from "react";

function AdqDetailGridNew(props) {

  const [tablDATA, setTableData] = useState([])

  const gridConfig = {
    gutter: 16,
    xs: 1,
    sm: 2,
    md: 2,
    lg: 3,
    xl: 3,
    xxl: 3,
  };

  useEffect(()=>{
    let dataOBj = JSON.stringify(props.dataSource)
    let tableData =  JSON.parse(dataOBj)

    // added for Roles ScreenName ...
    tableData.forEach((x)=>{           
      if(x.childScreenName && x.children && x.children.length > 0){
        x[x.childScreenName] = x.children[0][x.childScreenName]
        delete x.children;
      }      
    })
    setTableData(tableData)

  },[])


  return (
    <div className="mt-1">
      {props.dataSource ? (
        <List
          style={{ width: "100%" }}
          grid={gridConfig}
          dataSource={tablDATA}
          renderItem={(item) => {
            return (
              <List.Item>
                <AdqCard columns={props.columns} cardData={item} />
              </List.Item>
            );
          }}
          pagination={props.pagination}
        ></List>
      ) : (
        ""
      )}
    </div>
  );
}
export default AdqDetailGridNew;
